
export class JoyrideConstants {
  static readonly NO_POSITION: string = 'NO_POSITION';
  static readonly DISTANCE_FROM_TARGET: number = 15;
  static readonly ARROW_SIZE: number = 10;
}
